import { render } from "./projeto-editar-tarefas.vue?vue&type=template&id=a41d70ce&scoped=true"
import script from "./projeto-editar-tarefas.vue?vue&type=script&lang=js"
export * from "./projeto-editar-tarefas.vue?vue&type=script&lang=js"

import "./projeto-editar-tarefas.vue?vue&type=style&index=0&id=a41d70ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a41d70ce"]])

export default __exports__